jQuery(document).ready(function onArchiveReady($) {
    "use strict";

    var $form = $('.archive-page__messages__actions');

    $form.find('select').on('change', onChange);

    function onChange() {
        $form.trigger('submit');
    }
});